import { render, staticRenderFns } from "./group_management.vue?vue&type=template&id=28b83611&scoped=true&"
import script from "./group_management.vue?vue&type=script&lang=js&"
export * from "./group_management.vue?vue&type=script&lang=js&"
import style0 from "./group_management.vue?vue&type=style&index=0&id=28b83611&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b83611",
  null
  
)

export default component.exports